import React, { useState } from "react";
import ProfileImageAnonymus from "../assets/profile-elev.webp";
import {
  Image,
  Button,
  Descriptions,
  Divider,
  Popconfirm,
  Tabs,
  Alert,
} from "antd";
import { SettingOutlined, DeleteOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import EditProfesor from "./EditProfesor";
import { Tag } from "antd";
import ModalSettingsProf from "../Pages/Admin/ModalSettingsProf";
import { useDispatch } from "react-redux";
import { Input } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalChangePassword from "./ModalSchimbareParola";
import Condica from "../Pages/Profesori/Condica";
import {
  getDataDoc,
  updateDocDatabase,
  uploadFileDatabse,
  deleteDataDoc,
} from "../database";
import { db } from "../database/firebase";
import { onSnapshot, doc } from "firebase/firestore";
import "./ElevPage.css";
import { openErrorNotification } from "./Notifications/errorNotification";

import { getMaterieColor } from "../utils/index";
import "./ProfesorPage.css";
import "./ProfesorProfileModern.css";
import OrarProfesori from "../Pages/Profesori/OrarProfesori";
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";
import withErrorBoundary from "./withErrorComponent";
const { TextArea } = Input;
const colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
function ProfesorPage() {
  const { id } = useParams();
  const [profesorData, setProfesorData] = useState({});
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [tabKey, setTabKey] = useState("Orar");

  const materiiRedux = useSelector((state) => state.materii);
  const [open, setOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const clase = useSelector((state) => state.clase);
  const [docsProf, setDocsProf] = useState();
  const [materiiRes, setMateriiRes] = useState([]);
  const navigate = useNavigate();
  const [modalSchimbareParola, setModalSchimbaParola] = useState(false);
  const dispatch = useDispatch();
  const [resourcesProf, setResourcesProf] = useState([]);
  const [userData, setUserData] = useState({});
  const [classData, setClassData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const [mode, setMode] = useState("view");

  const fetchData = async () => {
    try {
      let data = await getDataDoc("profesori", id);

      if (
        data &&
        JSON.stringify(profesorData) !==
          JSON.stringify({
            ...data,
            ore: (data?.ore || []).map((el) => {
              return {
                ...el,
                startDate: new Date(el.startDate),
                endDate: new Date(el.endDate),
              };
            }),
            orePrivat: (data?.orePrivat || []).map((el) => {
              return {
                ...el,
                startDate: new Date(el.startDate),
                endDate: new Date(el.endDate),
              };
            }),
          })
      )
        setProfesorData({
          ...data,
          ore: (data?.ore || []).map((el) => {
            return {
              ...el,
              startDate: new Date(el.startDate),
              endDate: new Date(el.endDate),
            };
          }),
          orePrivat: (data?.orePrivat || []).map((el) => {
            return {
              ...el,
              startDate: new Date(el.startDate),
              endDate: new Date(el.endDate),
            };
          }),
        });
    } catch (err) {
      openErrorNotification(err.message);
    }
  };
  const materii = useSelector((state) => state.materii);

  const fetchUserData = async () => {
    const data = await getDataDoc("users", id);
    if (data && JSON.stringify(userData) !== JSON.stringify(data))
      setUserData(data);
  };

  fetchData();
  fetchUserData();
  const unsub = onSnapshot(doc(db, "profesori", id), (doc) => {
    fetchData();
  });
  const unsub2 = onSnapshot(doc(db, "users", id), (doc) => {
    fetchUserData();
  });

  const onChange = (key) => {
    setTabKey(key);
  };
  return (
    <div className="teacher-profile-page">
      <ModalSettingsProf
        open={open}
        confirmLoading={confirmLoading}
        setConfirmLoading={setConfirmLoading}
        profesorData={profesorData}
        setOpen={setOpen}
        setProfesorData={setProfesorData}
      />
      <ModalChangePassword
        open={modalSchimbareParola}
        email={profesorData.email || profesorData.adresaEmail}
        setOpen={setModalSchimbaParola}
        id={profesorData.id}
        setId={() => {}}
      />
      <div className="profile-header-modern">
        <div className="profile-info-section">
          <div>
            {mode === "view" ? (
              <>
                {process.env.REACT_APP_LIMIT_DATE === "enable" &&
                  userData?.treiSapt === true && (
                    <Alert
                      className="profile-alert-modern"
                      message={
                        "Profesorul poate pune note mai vechi de 3 săptămâni"
                      }
                      type="warning"
                      showIcon
                    />
                  )}

                <Descriptions
                  className="profile-descriptions-modern"
                  bordered
                  layout={window.innerWidth < 750 ? "vertical" : "horizontal"}
                  title={
                    <span className="profile-header-title">
                      {profesorData?.numeDeFamilie + " " + profesorData?.prenume}
                    </span>
                  }
                  extra={
                    user.type === "admin"
                      ? [
                          <Popconfirm
                            key="delete"
                            title="Ștergi profesorul?"
                            description="Profesorul va fi marcat ca șters și nu va mai apărea în liste."
                            onConfirm={async () => {
                              // Soft delete - marchează profesorul ca șters
                              await updateDocDatabase("profesori", id, {
                                deleted: true,
                                deletedAt: new Date().toISOString()
                              });
                              // Actualizează userul pentru a nu mai putea face login
                              await updateDocDatabase("users", id, {
                                active: false
                              });
                              // Forțează refresh pentru a actualiza Redux
                              window.location.href = "/profesori";
                            }}
                            okText="Șterge"
                            cancelText="Anulează"
                          >
                            <Button
                              className="profile-action-btn danger"
                              shape="circle"
                              icon={<DeleteOutlined />}
                              danger
                            />
                          </Popconfirm>,
                          <Button
                            key="settings"
                            className="profile-action-btn settings"
                            shape="circle"
                            onClick={() => setOpen(true)}
                            icon={<SettingOutlined />}
                          />,
                          <Button
                            key="edit"
                            className="profile-action-btn primary"
                            type="primary"
                            onClick={() => setMode("edit")}
                          >
                            Editează
                          </Button>,
                          <Button
                            key="password"
                            className="profile-action-btn"
                            onClick={() => setModalSchimbaParola(true)}
                          >
                            Schimbă parola
                          </Button>,
                        ]
                      : []
                  }
                >
                  <Descriptions.Item label="Nume">
                    {profesorData?.numeDeFamilie}
                  </Descriptions.Item>
                  <Descriptions.Item label="Prenume">
                    {profesorData?.prenume}
                  </Descriptions.Item>

                  <Descriptions.Item label="Nr. Telefon">
                    {profesorData?.numarTelefon}
                  </Descriptions.Item>

                  <Descriptions.Item label="Email">
                    {profesorData?.adresaEmail}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tip Cont">
                    {userData?.type}
                  </Descriptions.Item>
                  <Descriptions.Item label="OTP">
                    {userData?.otp === true ? "DA" : "NU"}
                  </Descriptions.Item>
                  <br />
                  <Descriptions.Item label="Materii">
                    <div className="profile-subject-tags">
                      {profesorData.selectedMaterii?.map((materie, index) => (
                        <Tag key={index} className="profile-subject-tag">
                          {materii?.find((mat) => mat.id === materie)
                            ?.numeMaterie +
                            " - " +
                            materii?.find((mat) => mat.id === materie)?.profil}
                        </Tag>
                      ))}
                    </div>
                  </Descriptions.Item>
                </Descriptions>
              </>
            ) : (
              <EditProfesor
                profesorData={profesorData}
                setMode={setMode}
                setProfesorData={setProfesorData}
                clase={clase}
                colors={colors}
                otpDefault={userData.otp}
                id={id}
                userData={userData}
              />
            )}
          </div>
        </div>
      </div>
      
      <Tabs
        className="profile-tabs-modern"
        size="large"
        onChange={onChange}
        activeKey={tabKey}
        items={[
          {
            label: `📅 Orar`,
            key: "Orar",
            children: <OrarProfesori profesorData={{ ...profesorData }} />,
          },
          (user.uid === profesorData.id || user.type === "admin") && {
            label: `📚 Condica`,
            key: "Condica",
            children: <Condica profesorData={profesorData} />,
          },
        ]}
      />
    </div>
  );
}

export default withErrorBoundary(ProfesorPage);
